import React, { useEffect, useRef, useState } from "react";
import { Button, Dropdown, Icon, Input } from "semantic-ui-react";

import SearchBox from "react-lib/apps/common/SearchBox";
import PopupBottomLeft from "./common/PopupBottomLeft";

const SubTreatmentPlanRow = (props: any) => {
  const doctorRef = useRef();
  const divisionRef = useRef();
  // const userPreferLangCookie = Cookies.get("user_lang") || "th";
  const [inputSearchDivision, setInputSearchDivision] = useState<string>("th");
  const [inputSearchDoctor, setInputSearchDoctor] = useState<string>("th");
  const [displaySeqValue, setDisplaySeqValue] = useState<number>(1);

  useEffect(() => {
    if (props.openModChangeDisplaySeq) {
      setDisplaySeqValue(props.treatmentPlan?.display_seq || 1);
    }
  }, [props.openModChangeDisplaySeq]);

  useEffect(() => {
    setDisplaySeqValue(props.treatmentPlan?.display_seq || 1);
  }, [props.treatmentPlan, props.treatmentPlan?.display_seq]);

  const handleSelectDropdown =
    (name: string) =>
      (data: any = {}) => {
        if (name === "division") {
          (divisionRef?.current as any)?.clear();
        }
        if (name === "doctor") {
          (doctorRef?.current as any)?.clear();
        }
        props.handleEvent({
          message: "handleUpdateTreatmentPlan",
          params: {
            pk: props.treatmentPlan?.id,
            exam_id: props.treatmentPlan?.examination,
            [name]: data?.id || null,
          },
        });
      };

  const handleIconClickDoctor = (name: string) => () => {
    // console.log("handleIconClickDoctor: ", name)
    if (props.treatmentPlan.doctor?.id && name === "doctor") {
      handleSelectDropdown(name)({ index: props.index });
    }
    if (props.treatmentPlan.division?.id && name === "division") {
      handleSelectDropdown(name)({ index: props.index });
    }
  };

  // Searchbox
  const handleGetSearchDoctor = (params: any) => {
    if (params.searchText) {
      const hasEnglish = /[A-Za-z]/.test(params.searchText);
      setInputSearchDoctor(hasEnglish ? "en" : "th");
      return props.handleEvent({
        message: "GetDoctorSearch",
        params: { name_code: params.searchText, lang: hasEnglish ? "en" : "th" },
      });
    }
  };

  const handleGetSearchDivision = (params: any) => {
    if (/^[a-zA-Z]+$/.test(params.searchText.trim()[0])) {
      setInputSearchDivision("en");
    } else {
      setInputSearchDivision("th");
    }
    return props.handleEvent({
      message: "GetDivisionSearch",
      params: { name: params.searchText },
    });
  };

  return (
    <div
      style={{
        width: "100%",
        display: "grid",
        gridTemplateColumns: props.gridTemplateColumns,
        marginBottom: props.insertAfterId === props.treatmentPlan.id ? "5px" : "0px",
        borderBottom: props.insertAfterId === props.treatmentPlan.id ? "solid #C8EBFB 1px" : props.styles.borderStyle,
        backgroundColor: props.insertAfterId === props.treatmentPlan.id ? "#C8EBFB" : "",
      }}
      draggable={false}
      onDragStart={(e) => {
        e.dataTransfer.setData("pk", props.treatmentPlan.id);
        e.dataTransfer.setData("exam_id", props.treatmentPlan.examination);
      }}
      onDragEnd={(e) => {
        e.preventDefault();
        props.setInsertAfterId("");
      }}
      onDragOver={(e) => {
        e.preventDefault();
        props.setInsertAfterId(props.treatmentPlan.id);
      }}
      onDrop={(e: any) => {
        e.preventDefault();

        props.handleEvent({ message: "handleUpdateTreatmentPlanDisplaySeq", params: { pk: +e.dataTransfer.getData("pk"), display_seq: props.index + 1 } });
        // props.handleEvent({
        //   message: "handleUpdateTreatmentPlan",
        //   params: {
        //     pk: +e.dataTransfer.getData("pk"),
        //     exam_id: e.dataTransfer.getData("exam_id"),
        //     display_seq: props.index + 1,
        //     type: "drag",
        //     toId: +props.insertAfterId,
        //   },
        // });

        const elm: any = e.target.getAttribute("draggable") ? e.target : e.target.parentElement;

        elm.style.transition = "transform 3s";
        elm.style.transform = "scale(0.8)";
        setTimeout(() => {
          elm.style.transition = "transform 3s";
          elm.style.transform = "";
        }, 300);

        props.setInsertAfterId("");
      }}
      onMouseDown={(event) => {
        if (props.readOnly) {
          event.preventDefault();
        }
      }}
    >
      <div style={{ display: "flex", justifyContent: "center", alignItems: "flex-start", paddingTop: "8px" }}>
        {/* {props.treatmentPlan?.display_seq} */}
        <div style={{ display: "flex", flexWrap: "nowrap", justifyContent: "center", alignItems: "center", minWidth: 0 }}>
          <Input
            type="number"
            style={{ flex: "0 1 70px", minWidth: 0, marginRight: "6px" }}
            input={{ style: { width: "100%", minWidth: 0, padding: "0.67857143em 0.5em" } }}
            value={displaySeqValue}
            onChange={(_event: any, data: any) => {
              setDisplaySeqValue(data.value);
            }}
            onKeyPress={(event: any) => {
              if (event.key === "Enter") {
                props.handleEvent({ message: "handleUpdateTreatmentPlanDisplaySeq", params: { pk: props.treatmentPlan?.id, display_seq: event.target.value } });
              }
            }}
          />
          <Icon
            name="caret up"
            size="big"
            style={{ margin: 0, flexShrink: 0, cursor: "pointer" }}
            onClick={() => {
              props.handleEvent({ message: "handleUpdateTreatmentPlanDisplaySeq", params: { pk: props.treatmentPlan?.id, display_seq: displaySeqValue - 1 } });
              // props.handleEvent({
              //   message: "handleUpdateTreatmentPlan",
              //   params: {
              //     pk: props.treatmentPlan?.id,
              //     exam_id: props.treatmentPlan?.examination,
              //     display_seq: (props.treatmentPlan?.display_seq || 0) - 1,
              //     type: "top",
              //     index: props.index,
              //   },
              // });
            }}
          />
          {/* )}
          {props.index !== props.length - 1 && ( */}
          <Icon
            name="caret down"
            size="big"
            style={{ margin: 0, flexShrink: 0, cursor: "pointer" }}
            onClick={() => {
              props.handleEvent({ message: "handleUpdateTreatmentPlanDisplaySeq", params: { pk: props.treatmentPlan?.id, display_seq: displaySeqValue + 1 } });
              // props.handleEvent({
              //   message: "handleUpdateTreatmentPlan",
              //   params: {
              //     pk: props.treatmentPlan?.id,
              //     exam_id: props.treatmentPlan?.examination,
              //     display_seq: (props.treatmentPlan?.display_seq || 0) + 1,
              //     type: "down",
              //     index: props.index,
              //   },
              // });
            }}
          />
          {/* )} */}
        </div>
      </div>
      <div style={{ display: "flex", justifyContent: "center", alignItems: "flex-start", paddingTop: "8px" }}>
        <div style={{ display: "flex", justifyContent: "center", alignItems: "center", gap: "4px" }}>
          <Button
            labelPosition="right"
            icon="calendar plus outline"
            content="Select"
            size="tiny"
            onClick={(e) => {
              props.handleEvent({
                message: "handleCompleteTreatmentPlan",
                params: { data: props.treatmentPlan },
              });
            }}
          />
          {props.encounterId === props.treatmentPlan?.encounter && (
            <Icon
              name="remove"
              onClick={(e: any) => {
                // props.handleCancelTreatmentPlan(props.treatmentPlan);
                props.handleEvent({
                  message: "handleCancelTreatmentPlan",
                  params: {
                    pk: props.treatmentPlan?.id,
                    exam_id: props.treatmentPlan?.examination,
                    status: "X",
                    type: "delete",
                  },
                });
              }}
              link={true}
              color={!!props.treatmentPlan?.from_continue_treatment_plan ? undefined : "black"}
              style={{ marginTop: "-10px", color: !!props.treatmentPlan?.from_continue_treatment_plan ? "#CC661C" : "" }}
            />
          )}
        </div>
      </div>
      <div style={{ ...props.styles.labelStyle, color: props.treatmentPlan?.urgency === "E" ? "#FA1010" : "" }}>
        {
          <div>
            {props.treatmentPlan.examination_location}
            {props.treatmentPlan.description && (
              <PopupBottomLeft
                content={props.treatmentPlan.description}
                trigger={<Icon className="ignore-prevent" name="info circle" color="blue" size="large" style={{ marginLeft: "0.25rem", cursor: "pointer" }} />}
                hideOnScroll={false}
              />
            )}
          </div>
        }
      </div>
      <div style={props.styles.labelStyle}>{props.treatmentPlan.examination_principal_diagnosis}</div>
      <div
        style={{ ...props.styles.labelStyle, color: props.treatmentPlan?.urgency === "E" ? "#FA1010" : props.treatmentPlan?.urgency === "U" ? "#EAB928" : "" }}
      >
        {props.treatmentPlan.treatment?.name}
      </div>
      <div style={{ ...props.styles.labelStyle, color: props.treatmentPlan.estimate_visit < 0 ? "red" : "" }}>{props.treatmentPlan.estimate_visit}</div>
      <div style={{ ...props.styles.labelStyle, padding: "0.15rem", margin: 0 }}>
        {/* {props.treatmentPlan.division?.name} */}
        <PopupBottomLeft
          content={props.treatmentPlan.division?.name || ""}
          trigger={
            <div>
              <SearchBox
                name="division-name"
                id={`division-name-${props.treatmentPlan.id}`}
                autoComplete="division-name"
                ref={(instance: any) => {
                  if (instance) {
                    divisionRef.current = instance;
                  }
                }}
                placeholder="Clinic"
                textField={inputSearchDivision === "th" ? "name" : "name_en"}
                fluid={true}
                defaultText={props.treatmentPlan.division?.name || ""}
                defaultId={props.treatmentPlan.division?.id || null}
                // config
                icon={!!props.treatmentPlan.division?.id ? "close" : "search"}
                readOnly={!!props.treatmentPlan.division?.id}
                linkIcon={!!props.treatmentPlan.division?.id}
                // // callback
                onGetSearchOptions={handleGetSearchDivision}
                onSelectOption={handleSelectDropdown("division")}
                onIconClick={handleIconClickDoctor("division")}
              />
            </div>
          }
          hideOnScroll={false}
        />
      </div>
      <div style={{ ...props.styles.labelStyle, padding: "0.15rem", margin: 0 }}>
        {/* {props.treatmentPlan.doctor?.full_name} */}
        <PopupBottomLeft
          content={props.treatmentPlan.doctor?.full_name || ""}
          trigger={
            <div>
              <SearchBox
                name="dentist-name"
                id={`dentist-name-${props.treatmentPlan.id}`}
                autoComplete="dentist-name"
                ref={(instance: any) => {
                  if (instance) {
                    doctorRef.current = instance;
                  }
                }}
                placeholder="ทันตแพทย์"
                textField={inputSearchDoctor === "th" ? "full_name" : "full_name_en"}
                fluid={true}
                defaultText={props.treatmentPlan.doctor?.full_name || ""}
                defaultId={props.treatmentPlan.doctor?.id || null}
                // config
                icon={!!props.treatmentPlan.doctor?.id ? "close" : "search"}
                readOnly={!!props.treatmentPlan.doctor?.id}
                linkIcon={!!props.treatmentPlan.doctor?.id}
                // // callback
                onGetSearchOptions={handleGetSearchDoctor}
                onSelectOption={handleSelectDropdown("doctor")}
                onIconClick={handleIconClickDoctor("doctor")}
              />
            </div>
          }
          hideOnScroll={false}
        />
      </div>
      <div style={{ padding: "0.15rem" }}>
        <Dropdown
          fluid
          selection
          upward={false}
          options={props.statusExcludeCompleteOptions}
          value={props.treatmentPlan?.status}
          style={{ color: ["I", "R"].includes(props.treatmentPlan?.status) ? "#2CB84B" : "#2D9CDB" }}
          onChange={(event, data) => {
            if (data.value === "C") {
              props.handleEvent({
                message: "handleCompleteTreatmentPlan",
                params: { data: props.treatmentPlan },
              });
            } else if (data.value === "X") {
              props.handleCancelTreatmentPlan(props.treatmentPlan);
            } else {
              props.handleEvent({
                message: "handleUpdateTreatmentPlan",
                params: {
                  pk: props.treatmentPlan?.id,
                  exam_id: props.treatmentPlan?.examination,
                  status: data.value,
                },
              });
            }
          }}
        />
      </div>
      <div style={{ padding: "0.15rem" }}>
        <Dropdown
          fluid
          selection
          upward={false}
          options={props.urgencyOptions}
          value={props.treatmentPlan?.urgency}
          style={{ color: props.treatmentPlan?.urgency === "E" ? "#FA1010" : props.treatmentPlan?.urgency === "U" ? "#EAB928" : "" }}
          onChange={(event, data) => {
            props.handleEvent({
              message: "handleUpdateTreatmentPlan",
              params: {
                pk: props.treatmentPlan?.id,
                exam_id: props.treatmentPlan?.examination,
                urgency: data.value,
              },
            });
          }}
        />
      </div>
      <div style={props.styles.labelStyle}>
        {props.treatmentPlan.created_th || props.treatmentPlan.edited_th}
        <br />
        {props.treatmentPlan?.created_user_full_name || props.treatmentPlan.edit_user_full_name}
      </div>
    </div>
  );
};

export default SubTreatmentPlanRow;
